<template>
  <payment-method-list
    :organization-id="organizationId"
  >
    <template #actions><audit-trail-button entity-type="PaymentMethod" :organization-id="organizationId" /></template>
  </payment-method-list>
</template>

<script>
import AuditTrailButton from "@elements/AuditTrailButton.vue";
import PaymentMethodList from "@/components/elements/PaymentMethodList.vue"

export default {
  name: 'PaymentMethodsInbound',

  components: {
    AuditTrailButton,
    PaymentMethodList
  },

  computed: {
    organizationId() {
      return this.$route.params.id
    }
  }
}
</script>
